// extracted by mini-css-extract-plugin
export default {"title":"UserProfileWrapper_title__URnbf","description":"UserProfileWrapper_description__3LuLS"};